<template>
	<div id="juzu">
		<!--<swiper :options="swiperOption" ref="mySwiper">-->
			<!--<swiper-slide v-for="item in list3" :key="item.id">-->
				<!--<img :src="item.images.image_url" width="100%" height="auto" />-->
			<!--</swiper-slide>-->
		<!--</swiper>-->
		<div class="container ">
			<div class="search-tag">
				<div class="tag-con4">
					<div class="float-left tag-left2">作品类型</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model='theme' size="small" border=false @change="getsearch">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">院线电影</el-radio-button>
							<el-radio-button label="2">网络电影</el-radio-button>
							<el-radio-button label="3">数字电影</el-radio-button>
							<el-radio-button label="4">电视剧</el-radio-button>
							<el-radio-button label="5">网络剧</el-radio-button>
							<el-radio-button label="6">广告拍摄</el-radio-button>
							<el-radio-button label="7">MV拍摄</el-radio-button>
							<el-radio-button label="8">综艺节目</el-radio-button>
							<el-radio-button label="9">演出活动</el-radio-button>
							<el-radio-button label="10">其他</el-radio-button>
						</el-radio-group>

					</div>
					<div class="clearfix"></div>
				</div>
				<div class="tag-con4">
					<div class="float-left tag-left2">招募演员</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model='recruit' size="small" border=false @change="getsearch">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">男演员</el-radio-button>
							<el-radio-button label="2">女演员</el-radio-button>
							<el-radio-button label="3">老人演员</el-radio-button>
							<el-radio-button label="4">儿童演员</el-radio-button>
							<el-radio-button label="5">跟组演员</el-radio-button>
							<el-radio-button label="6">群众演员</el-radio-button>
							<el-radio-button label="7">特约演员</el-radio-button>
							<el-radio-button label="8">特技演员</el-radio-button>
							<el-radio-button label="9">特型演员</el-radio-button>
						</el-radio-group>

					</div>
					<div class="clearfix"></div>
				</div>
				<!-- <div class="tag-con4">
					<div class="float-left tag-left2">筹备地点</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model='prepare' size="small" border=false>
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">北京</el-radio-button>
							<el-radio-button label="2">上海</el-radio-button>
							<el-radio-button label="3">浙江横店</el-radio-button>
						</el-radio-group>
					</div>
					<div class="clearfix"></div>
				</div> -->
				<div class="tag-con4">
					<div class="float-left tag-left2">拍摄地点</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model='take_place' size="small" border=false @change="getsearch">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">北京</el-radio-button>
							<el-radio-button label="2">上海</el-radio-button>
							<el-radio-button label="3">浙江横店</el-radio-button>
							<el-radio-button label="4">其他</el-radio-button>
						</el-radio-group>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="tag-con4">
					<div class="float-left tag-left2">开机时间</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model='date' size="small" border=false @change="getsearch">
							<el-radio-button label="3">不限</el-radio-button>
							<el-radio-button label="1">半年以内开机</el-radio-button>
							<el-radio-button label="2">半年以上开机</el-radio-button>
						</el-radio-group>
					</div>
					<div class="clearfix"></div>
				</div>
				<!--<div style="width: 200px; margin: 20px auto;">-->
					<!--<input type="submit" class="bk-search-btn" @click="getsearch" value="GO" />-->
				<!--</div>-->
			</div>
			<div class="jz-list-con">
				<ul>
					<li class="jz-con-infor" v-for="item in list" :key="item.id">

						<div class="float-left">
							<router-link :to="'/juzucontent/'+item.id"><img class="" :src="item.picture" width="250" height="350" /></router-link>
							<div class="list-pic-foo" style="height:52px; position: relative;margin-top: -52px;background: rgba(0,0,0,0.5);color: #fff;">
								<span class="float-left" style="margin-top: 18px; margin-left: 20px;">
									更新时间：{{item.create_time}}
								</span>

								<div class="clearfix"></div>
							</div>
						</div>
						<div class="jz-con-wd float-left">
							<div style="height: 290px;">
								<p>剧组名称：{{item.movie_name}}</p>
								<p>作品类型：{{item.theme}}</p>
								<p style="overflow: hidden;text-overflow: ellipsis;width: 250px;white-space: nowrap">
                  地点：{{item.prepare}}</p>
								<p>拍摄地点：{{item.take_place}}</p>
								<p>开机时间：{{item.start_time}}</p>
								<p>拍摄周期：{{item.take_period}}</p>
								<p style="height: 70px;overflow: hidden;">剧组简介：{{item.synopsis}}</p>
							</div>

								<router-link class="float-left list-more" :to="'/juzucontent/'+item.id">了解更多</router-link>

						</div>

					</li>
					<div class="clearfix"></div>
				</ul>
				<v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false" @page-change="pageChange" v-if="list !== undefined" style="padding: 40px 0"></v-page>
				<div v-else="list !== undefined" class="empty">
					<img src="../assets/images/wuxinxi_img.png">
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper'
	import storage from '../storage/storage.js'
	import Axios from 'axios'
	import pageNation from './pageNation'

	export default {
		data() {
			return {
				info: {},
				totalRow: 100,
				pageArr: [],
				pageNum: 1,
				date: '3', //默认选中时间字段值为3的选项
				theme: '',
				recruit: '',
				prepare: '',
				take_place: '',
				list: [],
				list3: [],
				swiperOption: {
					autoplay: 3000,
					autoplayDisableOnInteraction: false,
					speed: 2000,
					loop:true,
				},
        seoList:{
			column_title: '剧组信息'
		}
			}

		},
		components: {
			swiper,
			swiperSlide,
			pageNation,
		},
    metaInfo() {
      return {
        title: this.seoList.column_title + '-打造影视行业优秀的资源聚合服务平台' || '-打造影视行业优秀的资源聚合服务平台',
        meta: [
        		{
				  name: 'keywords',
				  content: this.seoList.column_keywords
				},
			  {
				name: 'description',
				content: this.seoList.column_description
			  }
          ]
      }
    },
		methods: {
      getSeo(){
        let seoApi = 'https://api.yopoo.cn/api/v1/crewsearch'
        this.$http.get(seoApi)
          .then((res)=>{
            this.seoList = res.body.metas
            this.column_title = this.seoList.column_title
            this.column_keywords = this.seoList.column_keywords
            this.column_description = this.seoList.column_description
          },err =>{
            console.log(err)
          })
      },
			renderList(value) {
				this.pageNum = value;
				this.requestData();
			},
			requestData() { //剧组搜索渲染接口
				var api = 'https://api.yopoo.cn/api/v1/crewsearch?'
				this.$http.get(api, {
					params: {
						page: this.pageNum,
						count: 6,
					}
				}).then((res) => {
					this.list = res.body.data
				}, err => {
					console.log(err)
				})
			},
			pageChange(pInfo) {
				pInfo.pageSize = 10 //显示count数量
				this.pageNum = pInfo.pageNumber //页码

				this.$http.get('https://api.yopoo.cn/api/v1/crewsearch?date=' + this.date + '&theme=' + this.theme + '&recruit=' +
					this.recruit + '&prepare=' + this.prepare + '&take_place=' + this.take_place + '&page=' + this.pageNum +
					'&count=' + pInfo.pageSize + '&sort=esc' +
					'&order=id').then((res) => {
					window.scrollTo(0,0)
					this.list = res.body.data
					this.pageArr = res.body.pagination //返回分页数组
					this.totalRow = res.body.pagination.total
				}, (err) => {
					console.log(err)
				})
				this.info = pInfo

			},
			requestData3() {
				var api3 = 'https://api.yopoo.cn/api/v1/homeshow&property=2&count=3'
				this.$http.get(api3).then((response) => {

						this.list3 = response.body
					},
					err => {
						console.log(err)
					}
				)
			},

			getsearch() { //剧组搜索渲染接口

				var api = 'https://api.yopoo.cn/api/v1/crewsearch?date=' + this.date + '&theme=' + this.theme + '&recruit=' + this
					.recruit +
					'&prepare=' + this.prepare + '&take_place=' + this.take_place + '&page=1' + '&count=' + this.info.pageSize +
					'&sort=esc' +
					'&order=id'

				this.$http.get(api).then((res) => {
					this.list = res.body.data
					this.totalRow = res.body.pagination.total
				}, err => {
					console.log(err)
				})
			}
		},

    beforeMount() {
			this.requestData3();
			this.getSeo()
		}

	}
</script>
<style>
	.bk-list-pic1 ul li {
		margin: 0 8px;
	}

	.bklist-wd {

		margin: 0 auto;
		height: 36px;
		line-height: 36px;
		color: #fff;
		background: rgba(0, 0, 0, 0.5);
		margin-top: -36px;
		position: relative;
	}

	.bk-search-btn {
		width: 200px;
		height: 50px;
		background: #C8B9A6;
		border: none;
		border-radius: 50px;
		color: #fff;
		font-size: 30px;
		cursor: pointer;
	}

	.jz-list-con {


		padding: 30px 0;

	}

	.jz-list-con ul li {
		padding: 30px 0;
		border-bottom: 1px dashed #C8B9A6;
		display: flex;
	}

	.list-more:hover {
		color: #fff !important;
	}

	div.v-pagination>ul>li {
		height: 0;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Juzu.vue